import { lockField as lockFieldBackend } from '@/backend/lockField'
import { invariant } from '@/shared/utils/typeAssertions'
import { useWorkspaces } from '../Workspaces/useWorkspaces'
import type { Field } from './Fields/types'
import { useProject } from './useProject'

export const useFieldLock = () => {
  const workspacesStore = useWorkspaces()
  const projectStore = useProject()

  const toggleFieldLock = async (field: Field) => {
    const newGroundTruth = !field.groundTruth

    const workspaceId = workspacesStore.currentWorkspace?.id
    const projectId = projectStore.projectId

    invariant(workspaceId && projectId, 'Workspace ID and project ID are required')

    const response = await lockFieldBackend({
      workspaceId,
      projectId,
      entityId: field.entityId,
      propertyId: field.propertyId,
      groundTruth: newGroundTruth,
    })

    projectStore.updateField({ ...field, groundTruth: newGroundTruth })

    if (response.ok) {
      return
    }

    if (response.error) {
      projectStore.updateField({ ...field, groundTruth: !newGroundTruth })
      throw new Error(response.error.message)
    }
  }

  return {
    toggleFieldLock,
  }
}
